<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="1200"
    @click:outside="clickOutside"
  >
    <template v-slot:activator="{ attrs }">
      <p id="createFPBFromCA" v-bind="attrs" @click="openForm"></p>
    </template>
    <v-card>
      <v-card-title>
        <span class="text-h5" style="margin: auto">BUAT FPB DARI CA</span>
      </v-card-title>
      <v-form
        v-if="form != null"
        ref="createFPBFromCA"
        :disabled="loading"
        lazy-validation
        @submit.prevent="saveForm"
        style="position: relative"
      >
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="9" class="d-flex flex-column">
                <div class="d-flex justify-start align-center">
                  <div
                    class="d-flex align-center"
                    style="height: 28px; position: relative; left: 10px"
                  >
                    <v-radio-group
                      v-model="form.create_method"
                      mandatory
                      :column="false"
                    >
                      <div
                        class="mr-3 d-flex justify-start align-center"
                        style="width: 160px"
                      >
                        <v-radio :value="'fpb_new'"></v-radio>
                        <p style="margin: 0; font-size: 12px">Buat FPB Baru</p>
                      </div>
                      <div
                        class="d-flex justify-center align-center"
                        style="width: 210px"
                      >
                        <v-radio :value="'fpb_existing'"></v-radio>
                        <p style="margin: 0; font-size: 12px">
                          Kaitkan dengan FPB Existing
                        </p>
                      </div>
                    </v-radio-group>
                  </div>
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  No. Payment Request
                </p>

                <div style="height: 40px">
                  <v-text-field
                    :value="detail.document_no"
                    disabled
                    dense
                    outlined
                    style="font-size: 12px"
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  PIC
                </p>

                <div style="height: 40px">
                  <v-text-field
                    :value="form.employee.name"
                    dense
                    outlined
                    style="font-size: 12px"
                    disabled
                  />
                </div>
              </v-col>
              <v-col cols="12" md="4" class="d-flex flex-column">
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Perusahaan
                </p>
                <div style="height: 40px">
                  <v-autocomplete
                    v-model="form.company"
                    :items="dropdown.company"
                    item-text="name"
                    item-value="id"
                    return-object
                    outlined
                    dense
                    style="margin: 0"
                    disabled
                  ></v-autocomplete>
                </div>
              </v-col>
              <!-- <v-col cols="12" md="4"></v-col> -->
              <v-col
                v-if="form.create_method == 'fpb_new'"
                cols="12"
                class="d-flex flex-column"
              >
                <v-row>
                  <v-col cols="12" md="4" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Deparment
                    </p>

                    <div style="height: 40px">
                      <v-autocomplete
                        v-model="form.department"
                        :items="dropdown.department"
                        item-text="name"
                        item-value="id"
                        style="font-size: 12px"
                        return-object
                        dense
                        outlined
                        clearable
                        @keydown.enter.prevent
                      ></v-autocomplete>
                    </div>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Kategori Barang
                    </p>

                    <v-autocomplete
                      v-model="form.category_item"
                      :items="dropdown.category_item"
                      item-text="name"
                      item-value="id"
                      style="font-size: 12px; height: 45px"
                      return-id
                      dense
                      outlined
                      clearable
                      @keydown.enter.prevent
                    ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" md="4" class="d-flex flex-column">
                    <p
                      class="text-left"
                      style="
                        margin: 0;
                        font-size: 12px;
                        font-weight: bold;
                        color: rgba(0, 0, 0, 0.5);
                      "
                    >
                      Kategori PR
                    </p>

                    <v-autocomplete
                      v-model="form.category_pr"
                      :items="dropdown.category_pr"
                      style="font-size: 12px; height: 45px"
                      item-text="name"
                      item-value="id"
                      return-id
                      dense
                      outlined
                      clearable
                      @keydown.enter.prevent
                    ></v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                v-if="form.create_method == 'fpb_existing'"
                cols="12"
                md="8"
                class="d-flex flex-column"
              >
                <p
                  class="text-left"
                  style="
                    margin: 0;
                    font-size: 12px;
                    font-weight: bold;
                    color: rgba(0, 0, 0, 0.5);
                  "
                >
                  Cari Nomor FPB
                </p>

                <div style="height: 40px">
                  <v-autocomplete
                    v-model="form.fpb"
                    :items="dropdown.fpb"
                    :search-input.sync="searchFpb"
                    item-text="request_no"
                    item-value="id"
                    style="font-size: 12px"
                    return-object
                    dense
                    outlined
                    clearable
                    @keydown.enter.prevent
                    @change="fpbItemWatcher"
                  ></v-autocomplete>
                </div>
              </v-col>
            </v-row>

            <div style="margin-top: 30px">
              <v-data-table
                max-height="50vh"
                mobile-breakpoint="0"
                style="cursor: pointer; border: 1px solid rgba(0, 0, 0, 0.2)"
                :headers="fpbItemHeaders"
                :items="form.ca_detail"
                :items-per-page="10"
                item-key="id"
              >
                <template v-slot:[`item.no`]="{ index }">
                  <div style="width: 35px">
                    {{ index + 1 }}
                  </div>
                </template>
                <template v-slot:[`item.prd_id`]="{ item }">
                  <div style="width: 120px; font-size: 12px; height: 45px">
                    <v-autocomplete
                      v-model="item.prd_id"
                      :items="dropdown.fpb_items"
                      item-text="product_name"
                      item-value="id"
                      return-id
                      dense
                      style="font-size: 10px"
                    >
                      <template v-slot:item="data">
                        <template>
                          <v-list-item-content>
                            <v-list-item-title style="font-size: 11px">
                              ({{ data.item.product_code }})
                              {{ data.item.product_name }}
                            </v-list-item-title>
                          </v-list-item-content>
                        </template>
                      </template>
                    </v-autocomplete>
                  </div>
                </template>
                <template v-slot:[`item.product_code`]="{ item }">
                  <div style="width: 95px; font-size: 12px">
                    {{ item.product_code }}
                  </div>
                </template>
                <template v-slot:[`item.product_name`]="{ item }">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <div
                        v-bind="attrs"
                        v-on="on"
                        style="
                          text-align: left;
                          width: 250px;
                          font-size: 12px;
                          padding: 0;
                        "
                      >
                        {{
                          `${
                            item.product_code !== null
                              ? '(' + item.product_code + ')'
                              : ''
                          } ${item.product_name}`
                        }}
                      </div>
                    </template>
                    <span>
                      {{
                        `${
                          item.product_code !== null
                            ? '(' + item.product_code + ')'
                            : ''
                        } ${item.product_name}`
                      }}</span
                    >
                  </v-tooltip>
                </template>
                <template v-slot:[`item.qty_request`]="{ item }">
                  <div
                    class="d-flex justify-center align-center"
                    style="width: 35px; font-size: 12px"
                  >
                    {{ item.qty_request }}
                  </div>
                </template>
                <template v-slot:[`item.uom_name`]="{ item }">
                  <div style="width: 45px; font-size: 12px">
                    {{ item.uom_name }}
                  </div>
                </template>
                <template v-slot:[`item.price_request`]="{ item }">
                  <div style="width: 45px; font-size: 12px">
                    {{ item.price_request }}
                  </div>
                </template>
                <template v-slot:[`item.description`]="{ item }">
                  <div style="width: 215px; font-size: 12px">
                    {{ item.description }}
                  </div>
                </template>
              </v-data-table>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <div style="padding: 0 25px 20px; width: 100%">
            <v-btn
              style="width: 100%"
              color="blue darken-1"
              class="white--text"
              type="submit"
              :loading="loading"
            >
              SIMPAN
            </v-btn>
            <v-btn
              style="width: 100%; margin-top: 15px"
              color="pink"
              class="white--text"
              @click="closeDialog"
              :loading="loading"
            >
              BATAL
            </v-btn>
          </div>
          <!-- <v-btn color="blue darken-1" text type="submit"> Save </v-btn> -->
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../services/buildType'
import { companyCodeMixin } from '../../../mixin/companyCode.js'
// import moment from 'moment'
export default {
  name: 'FormCaToFpb',
  mixins: [companyCodeMixin],
  props: ['detail'],
  data() {
    return {
      proc: buildType.apiURL('proc'),
      hrsApi: buildType.apiURL('hrs'),
      eSanquaApi: buildType.apiURL('esanqua'),
      loading: false,
      dialog: false,
      form: null,
      dropdown: {
        department: [],
        company: [],
        category_item: [],
        category_pr: [],
        fpb: [],
        fpb_items: []
      },
      searchFpb: null,
      selectedFpb: null
    }
  },
  computed: {
    ...mapGetters(['getUserProfile']),
    fpbItemHeaders() {
      const arrHeaders = [
        {
          text: 'No',
          value: 'no',
          align: 'left'
          // sortable: true,
        }
      ]
      if (this.form.create_method == 'fpb_existing') {
        arrHeaders.push({
          text: 'Pilih Item FPB',
          value: 'prd_id',
          align: 'left'
          // sortable: false,
        })
      }
      arrHeaders.push(
        {
          text: 'Kode Barang',
          value: 'product_code',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Nama Barang',
          value: 'product_name',
          align: 'left'
          // sortable: false,
        },
        {
          text: 'Qty Request',
          value: 'qty_request',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Satuan',
          value: 'uom_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Harga',
          value: 'price_request',
          align: 'left',
          // sortable: true,
          sortable: false
        },
        {
          text: 'Deskripsi',
          value: 'description',
          align: 'left',
          // sortable: true,
          sortable: false
        }
      )
      // if (this.detail.status.id === 0) {
      return arrHeaders
      // }
    }
  },
  watch: {
    searchFpb(val) {
      if (val !== '') {
        val && val !== this.selectedFpb && this.getDropdownFpbNo(val)
      } else {
        this.selectedFpb = null
        this.dropdown.fpb = []
      }
    }
  },
  mounted() {},
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    fpbItemWatcher(v) {
      if (v) {
        this.getDropdownFPBItems()
      } else {
        this.dropdown.fpb_items = []
      }
    },
    getDropdownFpbNo(v) {
      let url = `${this.proc}fpb/dropdown?keyword=${v}&offset=0&limit=1000&order_by=id&order_type=DESC`
      if (this.form.company !== null) {
        url = url + `&company_id=${this.form.company.id}`
      }
      axios
        .get(url)
        .then((res) => {
          // this.loading = false
          if (res.data.status_code === '00') {
            return (this.dropdown.fpb = res.data.data)
          }
          return (this.dropdown.fpb = [])
        })
        .catch((err) => {
          this.dropdown.fpb = []
          return console.log(err)
        })
    },
    getDropdownFPBItems(v) {
      const url = `${this.proc}fpb/item/dropdown?keyword=&offset=0&limit=all&filter=[{"request_id":${this.form.fpb.id}}]`
      console.log(url)
      axios
        .get(url)
        .then((res) => {
          // this.loading = false
          if (res.data.status_code === '00') {
            return (this.dropdown.fpb_items = res.data.data)
          }
          return (this.dropdown.fpb_items = [])
        })
        .catch((err) => {
          this.dropdown.fpb = []
          return console.log(err)
        })
    },
    openForm() {
      console.log('hallo world', this.detail)
      const arrDetails = []
      const objForm = {
        act: 'add_batch_in_item',
        payment_request_id: this.detail.id,
        employee: {
          id: this.getUserProfile.employee.id,
          name: this.getUserProfile.employee.name
        },
        company: {
          id: Number(this.detail.company_id),
          name: this.detail.company_name,
          code: this.getCompanyCode(Number(this.detail.company_id))
        },
        // company: {
        //   id: Number(this.getUserProfile.employee.company.id),
        //   name: this.getUserProfile.employee.company.name,
        //   code: this.getCompanyCode(
        //     Number(this.getUserProfile.employee.company.id)
        //   )
        // },
        department: {
          id: Number(this.getUserProfile.employee.department.id),
          name: this.getUserProfile.employee.department.name
        },
        category_item: null,
        category_pr: null,
        create_method: 'new_fpb',
        fpb: null
      }
      if (this.detail.payment_request_detail != null) {
        for (let i = 0; i < this.detail.payment_request_detail.length; i++) {
          if (this.detail.payment_request_detail[i].status == 0) {
            arrDetails.push({
              no: i + 1,
              // pjca_detail_id: this.detail.payment_request_detail[i].id,
              product_id: this.detail.payment_request_detail[i].product_id,
              product_name: this.detail.payment_request_detail[i].product_name,
              product_code: this.detail.payment_request_detail[i].product_code,
              qty_request: this.detail.payment_request_detail[i].qty_request,
              price_request:
                this.detail.payment_request_detail[i].price_request,
              // qty_done: this.detail.payment_request_detail[i].qty_request,
              // price_done: this.detail.payment_request_detail[i].price_request,
              uom_id: this.detail.payment_request_detail[i].uom_id,
              uom_name: this.detail.payment_request_detail[i].uom_name,
              prd_id: this.detail.payment_request_detail[i].prd_id,
              cad_id: this.detail.payment_request_detail[i].id,
              description: this.detail.payment_request_detail[i].product_name
            })
          }
        }
      }

      Object.assign(objForm, {
        ca_detail: arrDetails
      })
      console.log('openFormFPB>>>', objForm)

      this.form = objForm
      this.getDropdownCompany()
      this.getDropdownDepartment()
      this.getDropdownCategoryItem()
      this.getDropdownCategoryPr()
      setTimeout(() => {
        // this.startWatcher()
        this.dialog = true
      }, 300)
    },
    // clear() {
    //   this.$emit('loadPage')
    // },
    clickOutside() {
      //   this.closeDialog()
    },
    closeDialog() {
      setTimeout(() => {
        this.dialog = false
      }, 200)
    },
    saveForm() {
      const self = this
      setTimeout(function () {
        if (self.$refs.createFPBFromCA.validate()) {
          if (self.form.create_method == 'fpb_new') {
            self.checkBeforeSubmitFpb()
          }
          if (self.form.create_method == 'fpb_existing') {
            self.linkedCaToExistingFPB()
          }
        }
      })
    },
    linkedCaToExistingFPB() {
      if (!this.form.fpb) {
        return this.showMsgDialog(
          'warning',
          'Harap pilih FPB yang ingin dikaitkan',
          false
        )
      }
      const newForm = {
        payment_request_id: this.form.payment_request_id,
        purchase_request_id: this.form.fpb.id,
        mapping: this.form.ca_detail
      }
      console.log('newForm', newForm)
      this.showMsgDialog(
        'question',
        'Kaitkan CA dengan FPB Sekarang ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .post(`${this.proc}payreq/merge_ca_fpb`, newForm)
            .then((res) => {
              if (res.data.status_code == '00') {
                console.log('res.data', res.data)
                this.showMsgDialog('success', res.data.status_msg, false)
                this.dialog = false
                setTimeout(() => {
                  this.$emit('loadPage')
                }, 200)
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
              setTimeout(() => {
                this.dokumenDialog = false
              }, 300)
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog('error', err.message, false)
            })
        }
      })
    },
    checkBeforeSubmitFpb() {
      console.log('checkBeforeSubmitFpb', this.form)
      let xFlag = false
      if (!this.form.category_pr && !this.form.category_item) {
        this.showMsgDialog(
          'warning',
          'Harap pilih kategori PR dan kategori barang',
          false
        )
        return
      }
      // check category item
      if (this.form.category_pr === 'asset') {
        if (this.form.category_item === 7) {
          xFlag = false
        } else {
          this.showMsgDialog(
            'warning',
            'Pembelian asset, Kategori Barang dan Kategori PR wajib memilih Investment / Asset',
            false
          )
          return
        }
      } else {
        if (this.form.category_item !== 7) {
          xFlag = false
        } else {
          this.showMsgDialog(
            'warning',
            'Pembelian asset, Kategori Barang dan Kategori PR wajib memilih Investment / Asset',
            false
          )
          return
        }
      }

      // check category pr
      if (
        this.form.category_pr === 'asset' ||
        this.form.category_pr === 'project'
      ) {
        if (this.form.category_pr === 'asset') {
          const notAssetCode = this.form.ca_detail.find(
            ({ product_code }) =>
              (product_code != null && !product_code.includes('AST')) ||
              product_code == null
          )
          if (notAssetCode !== undefined) {
            this.showMsgDialog(
              'warning',
              "Kategori PR yang dipilih hanya untuk barang dengan kode 'AST'",
              false
            )
          } else {
            xFlag = true
          }
        } else {
          xFlag = true
          if (this.form.company.id != 5 && this.form.company.id != 14) {
            if (this.form.budget_plan) {
              xFlag = true
            } else {
              this.showMsgDialog(
                'warning',
                'FPB Project hanya bisa dibuat dari menu RAB',
                false
              )
            }
          } else {
            xFlag = true
          }
        }
      } else {
        const isAssetCode = this.form.ca_detail.find(
          ({ product_code }) =>
            (product_code != null && product_code.includes('AST')) ||
            product_code == null
        )
        if (isAssetCode !== undefined) {
          this.showMsgDialog(
            'warning',
            "Tidak dapat membuat FPB dengan kategori PR yang dipilih karena terdapat item dengan kode 'AST' ataupun freetext",
            false
          )
        } else {
          xFlag = true
        }
      }

      if (xFlag) {
        if (this.form.ca_detail == null || this.form.ca_detail.length == 0) {
          this.showMsgDialog('warning', 'Belum ada item yang diinput', false)
        } else {
          this.createNewForm()
        }
      }
    },
    createNewForm() {
      const prDetail = []
      const newForm = {
        act: 'add_batch_from_ca',
        payment_request_id: this.form.payment_request_id,
        employee_id: this.form.employee.id,
        employee_name: this.form.employee.name,
        company_id: this.form.company.id,
        company_code: this.form.company.code,
        company_name: this.form.company.name,
        department_id: this.form.department.id,
        department_name: this.form.department.name,
        category_item: this.form.category_item,
        category_pr: this.form.category_pr,
        fpb_type: 3 // mix
      }
      for (let i = 0; i < this.form.ca_detail.length; i++) {
        prDetail.push({
          cad_id: this.form.ca_detail[i].cad_id,
          budget_price_per_unit: this.form.ca_detail[i].price_request,
          description: this.form.ca_detail[i].description,
          // estimate_date_use: this.form.ca_detail[i].price_request
          product_id: this.form.ca_detail[i].product_id,
          product_code: this.form.ca_detail[i].product_code,
          product_name: this.form.ca_detail[i].product_name,
          uom_id: this.form.ca_detail[i].uom_id,
          uom_name: this.form.ca_detail[i].uom_name,
          qty: this.form.ca_detail[i].qty_request,
          qty_paid: this.form.ca_detail[i].qty_request,
          vendor_id: this.detail.vendor_id,
          vendor_code: this.detail.vendor_code,
          vendor_name: this.detail.vendor_name,
          estimate_date_use: this.detail.updatedAt,
          ca_type: 2,
          currency_code: 'IDR',
          currency_id: 1,
          currency_symbol: 'Rp'
        })
      }

      Object.assign(newForm, {
        purchase_request_detail: prDetail
      })

      this.submitFPB(newForm)
    },
    async submitFPB(form) {
      this.showMsgDialog(
        'question',
        'Kaitkan lanjut buat FPB dari CA ini ?',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .post(`${this.proc}fpb/save`, form)
            .then((res) => {
              this.loading = false
              if (res.data.status_code == '00') {
                const created_id = res.data.created_id
                console.log(created_id)
                this.showMsgDialog('success', res.data.status_msg, false)
                // this.closeDialog()
                setTimeout(() => {
                  // this.$store.commit('setFpbId', created_id)
                  this.$router.push(
                    `/e-catalogue/fpb-list/fpb/${created_id}?idx=0`
                  )
                }, 100)
              } else {
                if (res.data.status_msg === 'Parameter value has problem') {
                  this.showMsgDialog(
                    'warning',
                    'Invalid input, Parameter value has problem',
                    false
                  )
                } else {
                  this.showMsgDialog('warning', res.data.status_msg, false)
                }
              }
            })
            .catch((err) => {
              console.log(err)
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    async getDropdownDepartment() {
      await axios
        .get(
          `${this.hrsApi}master/universal/department/dropdown?filter=[{"company_id":${this.form.company.id}}]`
        )
        .then((res) => {
          console.log(res)
          if (res.data.status_code === '00') {
            return (this.dropdown.department = res.data.data)
          }
          return (this.dropdown.department = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.dropdown.department = [])
        })
    },
    getDropdownCompany() {
      this.dropdown.company = []
      axios
        .get(`${this.eSanquaApi}master/universal/plant/dropdown`)
        .then((res) => {
          // console.log('dropdowncompany', res)
          if (res.data.status_code == '00') {
            this.dropdown.company = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownCategoryItem() {
      const arr = [
        { id: 1, name: 'Raw Material' },
        { id: 2, name: 'Factory Supply' },
        { id: 3, name: 'Office Supply' },
        { id: 4, name: 'Sparepart' },
        { id: 5, name: 'Jasa' },
        { id: 6, name: 'Maintenance Repair' },
        { id: 7, name: 'Investment / Asset' },
        { id: 23, name: 'Event' }
      ]
      if (this.form != null && this.form.company != null) {
        if (this.form.company.id == 5 || this.form.company.id == 14) {
          arr.splice(
            2,
            4,
            {
              id: 8,
              name: 'Office Supply (< 1jt)'
            },
            {
              id: 9,
              name: 'Office Supply (1jt-5jt)'
            },
            {
              id: 10,
              name: 'Office Supply (> 5j)'
            },
            {
              id: 11,
              name: 'Marketing Material (< 1jt)'
            },
            {
              id: 12,
              name: 'Marketing Material (1jt-5jt)'
            },
            {
              id: 13,
              name: 'Marketing Material (> 5j)'
            },
            {
              id: 14,
              name: 'Sparepart (< 1jt)'
            },
            {
              id: 15,
              name: 'Sparepart (1jt-5jt)'
            },
            {
              id: 16,
              name: 'Sparepart (> 5j)'
            },
            {
              id: 17,
              name: 'Jasa (< 1jt)'
            },
            {
              id: 18,
              name: 'Jasa (1jt-5jt)'
            },
            {
              id: 19,
              name: 'Jasa (> 5j)'
            },
            {
              id: 20,
              name: 'Maintenance Repair (< 1jt)'
            },
            {
              id: 21,
              name: 'Maintenance Repair (1jt-5jt)'
            },
            {
              id: 22,
              name: 'Maintenance Repair (> 5j)'
            }
          )
        }
      }
      this.dropdown.category_item = arr
    },
    getDropdownCategoryPr() {
      this.dropdown.category_pr = [
        { id: 'bahan_baku', name: 'Bahan Baku' },
        { id: 'bahan_pendukung', name: 'Bahan Pendukung' },
        { id: 'asset', name: 'Asset' },
        { id: 'barang_khusus', name: 'Barang Khusus' },
        { id: 'operasional', name: 'Operasional' },
        { id: 'project', name: 'Project' },
        { id: 'lain', name: 'Lain-lain' }
      ]
    }
  }
}
</script>
